import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

import type { ICSSInJSStyle } from '@fluentui/styles';

export const MagazineWrapperContentStyle: ICSSInJSStyle = {
    height: '100%',
    overflow: 'hidden',
    padding: 0,
    border: 'none',
};

export const MagazineDialogStyle = {
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100vh',
    margin: 0,
    borderRadius: 0,
    background: 'rgba(0,0,0,0.45)',
};

export const MagazineHeaderStyle = {
    display: 'block',
    marginTop: pxToRem(30),
    marginLeft: pxToRem(28),
    marginBottom: pxToRem(-1),
};

export const CloseButton: StyleRule = ({ theme }) => ({
    position: 'absolute',
    top: pxToRem(8),
    right: pxToRem(8),
    zIndex: theme.siteVariables.zIndexes.overlayPriority,

    [theme.screen.laptop]: {
        top: pxToRem(16),
        right: pxToRem(23),
    },
});

export const MagazineTop: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(24),
    marginTop: pxToRem(45),
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    letterSpacing: '-0.01em',
    color: theme.siteVariables.colors.charcoal['000'],
});

const SCROLLBAR_WIDTH = 6;

export const MagazineWrapper: StyleRule = ({ theme }) => ({
    '&::-webkit-scrollbar': {
        width: pxToRem(SCROLLBAR_WIDTH),
    },

    '&::-webkit-scrollbar-track': {
        backgroundColor: theme.siteVariables.colors.white[300],
        borderRadius: pxToRem(30),
    },

    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.siteVariables.colors.gold['000'],
        borderRadius: pxToRem(30),
    },
});

export const MagazineDialog: StyleRule = () => ({});

export const MagazineNavs: StyleRule = ({ theme }) => ({
    position: 'absolute',
    top: '50%',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: pxToRem(8),
    zIndex: theme.siteVariables.zIndexes.overlayPriority,

    [theme.screen.laptop]: {
        paddingRight: pxToRem(23),
    },
});

export const MagazineIframeWrapper: StyleRule = ({ theme }) => ({
    position: 'relative',
    height: '100%',
    width: '100vw',
    paddingTop: pxToRem(78),
    paddingLeft: pxToRem(8),

    [theme.screen.laptop]: {
        paddingTop: 0,
        paddingLeft: 0,
        display: 'flex',
        justifyContent: 'center',
    },

    [theme.screen.max.tablet]: {
        paddingRight: pxToRem(8),
    },
});

// target width

export const MagazineIframe: StyleRule<{
    scalingFactor: number;
    iframeWidth: number;
    iframeHeight: number;
    dimensionsDetermined: boolean;
}> = ({
    theme,
    scalingFactor,
    iframeWidth,
    iframeHeight,
    dimensionsDetermined,
}) => {
    const dialogPadding = 50;
    const iframeContentWidth = iframeWidth - dialogPadding;
    const iframeContentHeight = iframeHeight - dialogPadding;

    return {
        display: 'block',
        transformOrigin: 'left top',
        maxHeight: '100%',
        maxWidth: '100%',
        width: `${iframeContentWidth}px`,
        height: `${iframeContentHeight}px`,
        [theme.screen.laptop]: {
            transform: 'none',
            height: '100%',
            width: '100%',
        },
        [theme.screen.max.tablet]: {
            // because the contents of this iframe is from hubspot with cors restrictions we scale on the iframe itself while reverse scale its bounds in proportion.
            display: `${dimensionsDetermined ? 'block' : 'none'}`,
            transform: `scale(${scalingFactor})`,
            maxWidth: `${100 / scalingFactor}%`,
            maxHeight: `${100 / scalingFactor}%`,
            width: `${iframeContentWidth / scalingFactor}px`,
            height: `${iframeContentHeight / scalingFactor}px`,
        },
    };
};
